import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField,
    Alert,
    CircularProgress,
    Box
} from '@mui/material';
import axios from 'axios';
import { useNotification } from '../../contexts/NotificationContext';

const REPORT_REASONS = {
    inappropriate_content: '不適切なコンテンツ',
    fake_listing: '虚偽の物件情報',
    scam: '詐欺の疑い',
    harassment: 'ハラスメント',
    spam: 'スパム',
    other: 'その他'
};

const ReportDialog = ({ open, onClose, targetType, targetId }) => {
    const [reason, setReason] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const { showNotification } = useNotification();

    const handleSubmit = async () => {
        if (!reason) {
            setError('通報理由を選択してください');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await axios.post('/api/reports', {
                targetType,
                targetId,
                reason,
                description
            });

            setSuccess(true);
            setLoading(false);
            showNotification('通報が送信されました。ご協力ありがとうございます。', 'success');

            // 3秒後に自動的にダイアログを閉じる
            setTimeout(() => {
                handleClose();
            }, 3000);
        } catch (error) {
            console.error('通報送信エラー:', error);
            const errorMessage = error.response?.data?.message || '通報の送信に失敗しました。後でもう一度お試しください。';
            setError(errorMessage);
            setLoading(false);
        }
    };

    const handleClose = () => {
        setReason('');
        setDescription('');
        setError('');
        setSuccess(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>
                {targetType === 'user' ? 'ユーザーを通報' : '物件を通報'}
            </DialogTitle>
            <DialogContent>
                {success ? (
                    <Alert severity="success" sx={{ my: 2 }}>
                        通報が送信されました。ご協力ありがとうございます。
                    </Alert>
                ) : (
                    <>
                        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                        <FormControl component="fieldset" sx={{ my: 2 }} fullWidth>
                            <FormLabel component="legend">通報理由</FormLabel>
                            <RadioGroup value={reason} onChange={(e) => setReason(e.target.value)}>
                                {Object.entries(REPORT_REASONS).map(([key, label]) => (
                                    <FormControlLabel
                                        key={key}
                                        value={key}
                                        control={<Radio />}
                                        label={label}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>

                        <TextField
                            label="詳細説明 (任意)"
                            multiline
                            rows={4}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            fullWidth
                            margin="normal"
                            placeholder="問題の詳細を記入してください"
                            inputProps={{ maxLength: 1000 }}
                            helperText={`${description.length}/1000`}
                        />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    {success ? '閉じる' : 'キャンセル'}
                </Button>
                {!success && (
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        disabled={loading || !reason}
                    >
                        {loading ? <CircularProgress size={24} /> : '通報を送信'}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default ReportDialog; 